import { inject, Injectable } from '@angular/core';
import { Device, TenantAccessPoint } from '../../../models/devices.model';
import { ConfirmHandler } from '../../dialog/dialog.model';
import { DialogService } from '../../dialog/dialog.service';
import { DeviceSelectionDialogComponent } from '../device-selection-dialog.component';

export type DeviceSelectionDialogResult<M extends boolean | undefined> = M extends true
  ? (Device | TenantAccessPoint)[]
  : Device | TenantAccessPoint;

@Injectable({
  providedIn: 'root',
})
export class DeviceSelectionDialogServiceService {
  private readonly _dialog = inject(DialogService);

  open<M extends boolean | undefined = false>(
    callback: ConfirmHandler<DeviceSelectionDialogResult<M>>,
    multi?: M,
    category?: 'robot' | 'access-point'
  ) {
    return this._dialog.open(
      DeviceSelectionDialogComponent,
      {
        multiple: multi ?? false,
        category: category ?? 'robot',
        onConfirm: callback,
      },
      {
        maxWidth: '560px',
        width: '100%',
      }
    );
  }
}
